<template>
  <div>
    <div class="row" v-if="author.affiliation">
      <div class="col-xs-12 well">

        <div class="clearfix"></div>

        <div class="row">
          <div class="col-md-2 col-xs-12 col-sm-3 item-label">
            <span>Information : </span>
          </div>
          <div class="col-md-10 col-xs-12 col-sm-9">

            <div class="row">
              <div class="col-xs-4">
                <div class="row">
                  <label class="col-xs-6">Status</label>
                  <span class="col-xs-6" v-if="author.affiliation.status_str">{{author.affiliation.status_str}}</span>
                  <span class="col-xs-6" v-else>n.a.</span>

                </div>
              </div>

              <div class="col-xs-4">
                <div class="row">
                  <label class="col-xs-6">Country</label>
                  <span class="col-xs-6" v-if="author.affiliation.country">{{author.affiliation.country}}</span>
                  <span class="col-xs-6" v-else>n.a.</span>
                </div>
              </div>

              <div class="col-xs-4">
                <div class="row">
                  <label class="col-xs-6">City</label>
                  <span class="col-xs-6" v-if="author.affiliation.city">{{author.affiliation.city}}</span>
                  <span class="col-xs-6" v-else>n.a.</span>
                </div>
              </div>
            </div>
            <div class="row" style="margin-top: 10px">
              <div class="col-xs-4">
                <div class="row">
                  <label class="col-xs-6">Incorp Date</label>
                  <span class="col-xs-6" v-if="author.affiliation.incorporation_date">{{author.affiliation.incorporation_date}}</span>
                  <span class="col-xs-6" v-else>n.a.</span>
                </div>
              </div>
              <div class="col-xs-4">
                <div class="row">
                  <label class="col-xs-6">Turnover</label>
                  <span class="col-xs-6" v-if="author.affiliation.turnover">{{ numberWithCommas }} €</span>
                  <span class="col-xs-6" v-else>n.a.</span>

                </div>
              </div>
              <div class="col-xs-4">
                <div class="row">
                  <label class="col-xs-6">Nb Employees</label>
                  <span class="col-xs-6" v-if="author.affiliation.nb_employees">{{author.affiliation.nb_employees}}</span>
                  <span class="col-xs-6" v-else>n.a.</span>
                </div>
              </div>
            </div>
            <div class="row" style="margin-top: 10px">
              <div class="col-xs-4">
                <div class="row">
                  <label class="col-xs-6">Category</label>
                  <span class="col-xs-6" v-if="author.affiliation.category">{{author.affiliation.category}}</span>
                  <span class="col-xs-6" v-else>n.a.</span>
                </div>
              </div>
              <div class="col-xs-4">
                <div class="row">
                  <label class="col-xs-6">Website</label>
                  <span class="col-xs-6" v-if="author.affiliation.website"><a :href=" cleanLink(author.affiliation.website)" target="_blank">link</a></span>
                  <span class="col-xs-6" v-else-if="author.affiliation.url"><a :href="cleanLink(author.affiliation.url)" target="_blank">link</a></span>
                  <span class="col-xs-6" v-else>n.a.</span>
                </div>
              </div>
              <div class="col-xs-4">
                <div class="row">
                  <label class="col-xs-6">Nb Patents</label>
                  <span class="col-xs-6" v-if="author.affiliation.nb_patents">{{author.affiliation.nb_patents}}</span>
                  <span class="col-xs-6" v-else>n.a.</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" style="margin-top: 15px">
          <div class="col-md-2 col-xs-12 col-sm-3 item-label">
            <span>Description : </span>
          </div>
          <div class="col-md-10 col-xs-12 col-sm-9">
            <span v-if="documentDescription && documentDescription.abstract" v-html="documentDescription.abstract"></span>
            <span v-else-if="author.affiliation.overview || author.affiliation.trade_description">{{author.affiliation.overview}}; {{author.affiliation.trade_description}}</span>
            <span v-else> No description available</span>
          </div>
        </div>
        <div class="row" style="padding-top: 15px" v-if="documentDescription  && documentDescription.sourceID && documentDescription.sourceID === 28">
          <div class="col-md-2 col-xs-12 col-sm-3 item-label">
            <span>Source : </span>
          </div>
          <div class="col-md-10 col-xs-12 col-sm-9 text-right">-
            <a :href="'https://en.wikipedia.org/?curid=' + documentDescription.sourceDocumentID"
               target="_blank">
              <img class="provider-img" :src="api_url + '/sources/wiki.png'">
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-for="(document, key) in documents" :key="key">

      <div class="col-xs-12 well" :class="{docInBiblio: document.biblio === true}">

        <div class="clearfix"></div>
        <div class="row m-b-xs">
          <document-action :key="'' +document.biblio" :document="document" :context="context"></document-action>
        </div>
        <div class="row">
          <div class="col-md-2 col-xs-12 col-sm-3 item-label">
            <span>Title : </span>
          </div>
          <div class="col-md-10 col-xs-12 col-sm-9 font-bold text-uppercase " style="line-height: 1.8">
            <span v-html="document.title"></span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-2 col-xs-4 col-sm-2 item-label">
            <span>Source : </span>
          </div>
          <div class="col-md-4 col-xs-8 col-sm-9 " style="line-height: 1.8">
            <span v-html="document.publication"></span>
          </div>
          <div class="col-md-2 col-xs-4 col-sm-2 item-label">
            <span>Date : </span>
          </div>
          <div class="col-md-4 col-xs-8 col-sm-9 " style="line-height: 1.8">
            <span>{{document.pubDate | moment('L')}}</span>
          </div>
        </div>
        <div class="row" v-if="document.co_authors.length !== 0">
          <div class="col-md-2 col-xs-4 col-sm-2 item-label">
            <span>Applicant : </span>
          </div>
          <div class="col-md-10 col-xs-8 col-sm-9 " style="line-height: 1.8">
          <span v-for="(inventor, key2) in document.co_authors" :key="key2">
            <template v-if="key2 !== 0">, </template> {{inventor.firstName}} {{inventor.lastName}}
          </span>
          </div>
        </div>
        <div class="row m-t-sm">
          <div class="col-md-2 col-xs-12 col-sm-3 item-label">
            <span>Abstract : </span>
          </div>
          <div class="col-md-10 col-xs-12 col-sm-9 text-justify " style="line-height: 1.8">
            <span v-html="document.abstract" class="text-justify"></span>
          </div>
        </div>
      </div>

    </div>
    <div class="row" v-if="context.name === 'expertSelected' && typeof documents[0] !=='undefined'">
      <div class="col-xs-12 well">
        <div class="row">
          <div class="col-md-2 col-xs-6 item-label">
            <span>Added To list: </span>
          </div>
          <div class="col-md-4 col-xs-6 ">
            <span>{{documents[0].added_at }}</span>
          </div>
          <div class="col-md-2 col-xs-6 item-label">
            <span>Search Query: </span>
          </div>
          <div class="col-md-4 col-xs-6 ">
            <span>{{documents[0].search_terms }}</span>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<style>
  .item-label {
    font-weight: bold;
  }

  .coAuthors-divider + .coAuthors-divider:before {
    content: ", ";
  }
  .docInBiblio{
    border-left: thick solid #3498db;
  }
  .provider-img {
    height: 25px;
  }
</style>
<script>

import DocumentAction from './DocumentAction'

export default {
  name: 'DocumentsCompany',
  components: {DocumentAction},
  props: ['value', 'author', 'context', 'pubDateSelected'],
  computed: {
    numberWithCommas: function () {
      let rounded = Math.round(this.author.affiliation.turnover)
      rounded *= 1000
      if (!isNaN(rounded)) {
        return Math.abs(Number(rounded)) >= 1.0e+9
          ? Math.round(Math.abs(Number(rounded)) / 1.0e+9) + ' bn'
        // Six Zeroes for Millions
          : Math.abs(Number(rounded)) >= 1.0e+6
            ? Math.round(Math.abs(Number(rounded)) / 1.0e+6) + ' m'
          // Three Zeroes for Thousands
            : Math.abs(Number(rounded)) >= 1.0e+3
              ? Math.round(Math.abs(Number(rounded)) / 1.0e+3) + ' k'
              : Math.abs(Number(rounded))
      }
      return 'n.a.'
    }
  },
  watch: {
    author: function (author) {
      // console.log('DocumentAuthor author', author)
    },
    value: function (val) {
      // console.log('update documents', val)
      this.documents = val
    },
    pubDateSelected: function (pubDateSelected) {
      let documents = this.author.docs

      if (pubDateSelected.length !== 0) {
        documents = documents.filter((document) => {
          let date = new Date(document.pubDate).getFullYear()
          let tmpYear = pubDateSelected.find((year) => {
            return date === year.name
          })
          return typeof tmpYear !== 'undefined'
        })
      }
      this.documents = documents
    }
  },
  data () {
    return {
      documents: null,
      documentDescription: null,
      api_url: process.env.API_URL
    }
  },
  methods: {
    cleanLink: function (link) {
      link = link.trim().toLowerCase()
      return link.startsWith('http:') || link.startsWith('https:') ? link : '//' + link
    }
  },
  beforeMount () {
    this.documents = this.value

    this.documents = this.documents.filter((document) => {
      if (document.publication !== 'European Patent Office') {
        this.documentDescription = document
        return false
      }
      return true
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/documents/DocumentsCompany.vue